export const defaultDetectionLayers = [
  // Dados esparsos
  {
    layer: 'sparseData',
    medianBelow: 15,
    meanBelow: 15,
    maxBelow: 15,
    medianWindow: 7,
    meanWindow: 180,
    maxWindow: 365,
  },

  // Comparação de períodos de calendário, ex mês atual vs mês anterior
  // Variação acumulada do ano (comparação anual) - Insight 8
  {
    layer: 'calendarPeriodComparisonDetection',
    periodType: 'year',
    focus: 'current',
    comparedTo: 'previous',
    percentageThreshold: 0.05, // 5%
    direction: 'both',
  },
  // Variação mensal (ano contra ano) - Insight 1
  {
    layer: 'calendarPeriodComparisonDetection',
    periodType: 'month',
    focus: 'current',
    comparedTo: 'previous',
    percentageThreshold: 0.05, // 5%
    direction: 'both',
  },
  // Tendência do mês atual (comparação anual) - Insight 2
  {
    layer: 'calendarPeriodComparisonDetection',
    periodType: 'month',
    focus: 'current',
    comparedTo: 'yearOverYear',
    percentageThreshold: 0.05, // 5%
    direction: 'both',
  },
  // Variação mês a mês - Insight 3
  {
    layer: 'calendarPeriodComparisonDetection',
    periodType: 'month',
    focus: 'previous',
    comparedTo: 'previous',
    percentageThreshold: 0.05, // 5%
    direction: 'both',
  },
  // Tendência do mês atual (comparação sequencial) - Insight 4
  {
    layer: 'calendarPeriodComparisonDetection',
    periodType: 'month',
    focus: 'previous',
    comparedTo: 'yearOverYear',
    percentageThreshold: 0.05, // 5%
    direction: 'both',
  },

  // Valor mensal fora do padrão histórico - Insight 5
  {
    layer: 'calendarPeriodMADDetection',
    periodType: 'month',
    focus: 'previous',
    limitMultiplier: 2.5,
  },
  // Valor semanal fora do padrão histórico - Insight 6
  {
    layer: 'calendarPeriodMADDetection',
    periodType: 'week',
    focus: 'previous',
    limitMultiplier: 2.5,
  },
  // Valor diário fora do padrão histórico - Insight 7
  {
    layer: 'calendarPeriodMADDetection',
    periodType: 'day',
    focus: 'previous',
    limitMultiplier: 2.5,
  },
] as const
